<template>
    <div class="chart"></div>
</template>

<script>
    import Vue from 'vue';
    import Highcharts from 'highcharts';

    export default {
        name: 'v-chart',
        props: {
            options: {
                type: Object,
                default: () => ({}),
            },
            series: {
                type: Array,
                default: () => [],
            },
        },
        computed: {
            defaultOptions() {
                return {
                    credits: {
                        enabled: false,
                    },
                };
            },
            mergedOptions() {
                return Highcharts.merge(this.defaultOptions, this.options);
            },
        },
        data() {
            return {
                chart: null,
            };
        },
        methods: {
            reflow() {
                Vue.nextTick(() => this.chart.reflow());
            },
        },
        created() {
            this.$on('reflow', this.reflow);
        },
        mounted() {
            this.chart = Highcharts.chart(this.$el, this.mergedOptions);
        },
    };
</script>
